import { Box } from "@mui/material";
import React from "react";

import { fullPageBoxStyle } from "../../../../../styles/muiProps";
import { useParams } from "react-router-dom";
import NavTabs from "../../../../../components/Tabs/NavTabs";
import Tabs from "@mui/material/Tabs";

import EstimationBOMTab from "./EstimationBOM";
import EstimationSummaryTab from "./Tank_Estimation_Summary";
import EstimationTab from "./Tank_Estimation";

const Estimation = (props) => {
  // const { projectId, equipID: equipId } = props;
  const { projectId, equipId } = useParams();
  const [tab, setTab] = React.useState(0); ///value of tab

  const handleChange = (event, newTab) => {
    console.log("eeeeeee", event);

    setTab(newTab);
  };

  const parentTypes = ["struc", "pip", "Pressure Vessel"];
  const [currentParentType, setCurrentParentType] = React.useState(
    parentTypes[0]
  );

  React.useEffect(() => {
    console.log("xxxxxxxxxxxx");

    setCurrentParentType(parentTypes[tab]);
    console.log("changing tabnnnn", parentTypes[tab], tab);
  }, [tab]);

  const tabs = [
    {
      label: "Estimation",
      panel: (
        <EstimationTab
          plant={props.plant}
          parentTabIndex={tab}
          parentType={currentParentType}
        />
      ),
    },
    {
      label: "Estimation Summary",
      panel: (
        <EstimationSummaryTab
          plant={props.plant}
          parentTabIndex={tab}
          parentType={currentParentType}
        />
      ),
    },
    {
      label: "Estimation BOM",
      panel: (
        <EstimationBOMTab
          plant={props.plant}
          parentTabIndex={tab}
          parentType={currentParentType}
        />
      ),
    },
  ];

  return (
    <Box
    // sx={{
    //   flexGrow: 1,
    //   bgcolor: "background.paper",
    //   display: "flex",
    //   "& .Mui-disabled": {
    //     color: "red",
    //     "-webkit-text-fill-color": "#000000",
    //   },
    // }}
    // {...fullPageBoxStyle}
    >
      {props.plant && (
        <>
          <NavTabs
            setCurerrentTabParent={setTab}
            // value={tab}
            tabs={[
              {
                label: "Structure",
                panel: (
                  <NavTabs
                    tabs={tabs}
                    // tabProps={verticalTabStyle}
                    navLabel="est-tab"
                    // vertical={true}
                  />
                ),
              },
              {
                label: "Piping",
                panel: (
                  <NavTabs
                    tabs={tabs}
                    // tabProps={verticalTabStyle}
                    navLabel="est-tab"
                    // vertical={true}
                  />
                ),
              },
              {
                label: "Pressure Vessel",
                panel: (
                  <NavTabs
                    tabs={tabs}
                    // tabProps={verticalTabStyle}
                    navLabel="est-tab"
                    // vertical={true}
                  />
                ),
              },
            ]}
            navLabel="structure-piping-pressure-vessel-tab"
          />
        </>
      )}
      {!props.plant && (
        <NavTabs
          tabs={tabs}
          // tabProps={verticalTabStyle}
          navLabel="est-tab"
          // vertical={true}
        />
      )}
    </Box>
  );
};

export default Estimation;
